import '.ad{border-radius:1.25rem;}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.g7{border:var(--gray-border);}.ssr-plugin'
import '.g8{min-height:420px;}.ssr-plugin'
import '.bd{height:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import { Style, styled } from 'inlines'

export interface SlideShareEmbedProps {
  src: string
  style?: Style
  className?: string
}

export const SlideShareEmbed = ({
  src,
  style,
  className,
}: SlideShareEmbedProps) => {
  return (
    <styled.div className={`${className} ad p g7 g8 bd a e`}
      style={{
        ...style,
      }}
    >
      <iframe
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        scrolling="no"
        allowFullScreen
        style={{
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
        }}
      />
    </styled.div>
  )
}
